export default __webpack_public_path__ + "static/Geologica-ExtraBold-eb501e8905f80a73e1dfc903c709075a.woff2";